import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import Vue2TouchEvents from "vue2-touch-events";
import Vuex from "vuex";
import "es6-promise/auto";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.use(Vuex);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
